import { Step } from 'signup-constants/Step';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getHttpResponse } from '../../store/http-responses/selectors';
import { EndpointKey } from '../../http/EndpointKey';
import { isExistingUser } from '../../app/verificationTypeSelectors';
export const BranchAddHubletExistingUser = {
  name: 'BranchAddHubletExisitngUser',
  stateCheck: state => {
    const httpResponse = getHttpResponse(state, EndpointKey.HubletChoiceExistingUser);
    return isExistingUser(state) && Boolean(httpResponse) && httpResponse.availableHublets && httpResponse.availableHublets.length > 1;
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.addLastStepsBeforeAccountCreation(Step.HubletSelection));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};